import { StdResponse, request } from "@/global/config/request";
import { RsProjectGlobalSensor } from "@/global/interface/project-device/project-sensor";

export function getProjectSensors(projectId: number, type: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/project-global-sensors`, {
        params: {
            ...params,
            type: type,
        }
    })
}

export function createProjectGSensors(data: RsProjectGlobalSensor[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/project-global-sensors`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectGSensor(projectId: number, globalSensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/project-global-sensors/delete`, {
        params: {
            ...params,
            projectId: projectId,
            globalSensorId: globalSensorId,
        }
    })
}   